<template>
  <div v-loading.fullscreen.lock="loading" class="main right" :class="[ type === 1 ? 'student' : type === 2 ? 'teacher' : type === 3 ? 'criticism' : 'innovation' ]">
    <div v-if="[3, 4, 5].indexOf(type) === -1" class="headerTop">
      <div v-if="type === 1">
        <img src="@/assets/exam/theme1/w_js@2x.png" alt="">
      </div>
      <div v-else-if="type === 2">
        <img src="@/assets/exam/theme0/w_js@2x.png" alt="">
      </div>
    </div>
    <div ref="answer" class="content">
      <div class="elapsedTime" v-if="[3, 4, 5].indexOf(type) === -1">
        <span>总时长:</span>
        <div class="progress">
          <el-progress
            color="#667C6B"
            :show-text="false"
            :percentage="percentage"
          ></el-progress>
          <div class="pastTime" :style="{left, backgroundImage: `url(`+ themeList[type - 1]['--progress-tip-bg'] +')'}">
            <span>{{ minute }}分钟</span>
          </div>
        </div>
        <div class="time">{{type === 2 ? 60 : 30}}分钟</div>
      </div>
      <template v-for="(item, index) of list">
        <div v-if="item.type === 1" :key="index" class="front">
          <div class="list listFirst">亲爱的同学：</div>
          <div class="list">
            在这份问卷中，你将看到一些与自己的个人特征和学习生活有关的描述。请你在认真阅读每一道题目后，找到最接近自己真实情况的选项并点击。注意每题只选一个，不要漏题！
          </div>
          <div class="list">
            问卷中的每个问题都没有正确与错误之分,所有结果仅为科学研究所用。
          </div>
          <div class="list">如果你还有什么不明白的地方，请向老师提问。</div>
          <div class="list">感谢你的热情参与！</div>
          <img src="@/assets/line.png" alt="">
        </div>
        <div v-if="item.type === 5" :key="index" class="front">
          <div class="list listFirst">尊敬的老师：</div>
          <div class="list">您好！</div>
          <div class="list">
            在这份问卷中，您将看到一些与课堂教学行为与教师教学观念有关的描述。请您认真地阅读每一道题目，仔细思索，找到最接近自己真实情况的选项并点击。注意一般每题只选一个答案（多选题会在题后括号内说明），请勿漏题！
          </div>
          <div class="list">
            问卷中的每个问题都没有正确与错误之分，所有结果仅为科学研究所用。
          </div>
          <div class="list">感谢你的热情参与！</div>
          <img src="@/assets/line.png" alt="" />
        </div>
        <div v-if="item.type === 3" :key="index" class="title">
          <div v-if="current === 0 && [3, 4, 5].indexOf(type) === -1">一、</div>
          <div v-else-if="current === 1 ">二、</div>
          <div v-else-if="current === 2">三、</div>
          <div v-else-if="current === 3">四、</div>
          <div v-else-if="current === 4">五、</div>
          <span v-html="item.title" />
        </div>
        <div v-if="item.type === 2" :id="'id' + item.headline" :key="index" class="pascal" data-result-item="radio">
          <div class="list">
            <div class="headline">{{ item.headline }}</div>
            <div class="select">
              <el-radio
                class="selectRadio"
                :key="indexSon"
                :label="indexSon + 1"
                v-model="item.answer"
                v-for="(itemSon, indexSon) of item.value"
                :data-number="indexSon + 1"
              >
                <span>{{ itemSon }}</span>
              </el-radio>
            </div>
          </div>
        </div>
        <div v-if="item.type === 4" :key="index" class="titleSmall">
          <span class="titleSmall_title">{{ item.title }}</span>
          <div :id="'id' + it.headline" class="list" v-for="it in item.value" :key="it.headline" data-result-item="radio">
            <div class="headline">{{ it.headline }}</div>
            <div class="select">
              <el-radio
                class="selectRadio"
                :key="indexSon"
                :label="indexSon + 1"
                v-model="it.answer"
                v-for="(itemSon, indexSon) of it.value"
                :data-number="indexSon + 1"
              >
                <span>{{ itemSon }}</span>
              </el-radio>
            </div>
          </div>
        </div>
        <div v-if="item.type === 6 || item.type === 8" :id="'id' + item.headline" :key="index" class="pascal" data-result-item="checkbox">
          <div class="list">
            <div class="headline">{{ item.headline }}</div>
            <div class="select">
              <el-checkbox-group v-model="item.answerList" size="medium">
                <el-checkbox
                  :label="itemSon"
                  v-for="(itemSon, indexSon) of item.value"
                  :key="itemSon"
                  :data-label="itemSon"
                  :data-number="indexSon + 1"
                >
                  <div class="label" style="heght: 100%; font-size: 16px; algin-item: center" v-if="itemSon.type">
                    {{itemSon.value}}
                    <el-input v-model="itemSon.val" maxlength="20" v-if="itemSon.type && itemSon.type === 'input'"></el-input>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div v-if="item.type === 9" :key="index" class="front">
          <div class="list">
            {{item.title}}
          </div>
        </div>
        <div v-if="item.type === 7" :key="index" class="pascal" data-result-item="text">
          <div class="list">
            <div class="headline">{{ item.headline }}</div>
            <Record :isShowAnswer="true" :richText="false" dontStats></Record>
          </div>
        </div>
      </template>
    </div>
    <div class="sidebar" v-if="[3, 4, 5].indexOf(type) === -1">
      <img src="@/assets/logo.png" alt="">
      <div>
        <div class="list" :class="[current === index ? 'select' : '']" v-for="(item, index) in subSource" :key="index">
          <span>{{ item.title }}</span>
          <span>{{ 1 + '-' + item.value.length }}</span>
        </div>
      </div>
    </div>
    <div class="next" @click="next">{{ text }}</div>
    <el-dialog :visible="show" class="innovate" center :append-to-body='true' width="30%" :before-close="continueWord">
      <div class="text"> {{ $route.name === 'questionnaireStudent' ? '你' : '您'}}有未完成的小题， </div>
      <div class="text" v-if="dataSource.length - 1  === current"> 请您全部答完后再提交。 </div>
      <div class="text" v-else> 请完成后再点击下一题。 </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="continueWord">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { htmlToFile } from '@/utils/index.js'
import { answerUpload } from '@/services/exam'
import { postProcessStats, saveSurveyResult, parseStatsData } from '@/utils/stats'
import Record from '@/views/exam/paper/components/record'

export default {
  components: {
    Record
  },
  data() {
    return {
      data: [],
      radio: '11',
      list: [],
      current: 0,
      text: '下一题',
      show: false,
      subSource: [],
      percentage: 0,
      time: 0,
      minute: 0,
      name: '',
      left: 0,
      loading: false,
      themeList: [
        {
          '--progress-tip-bg': require('@/assets/exam/theme0/3.png'),
          '--dialog-bg-img': 'url(' + require('@/assets/exam/theme0/dialog_bg.png') + ')'
        },
        {
          '--progress-tip-bg': require('@/assets/exam/theme0/3.png'),
          '--dialog-bg-img': 'url(' + require('@/assets/exam/theme0/dialog_bg.png') + ')'
        },
        {
          '--progress-tip-bg': require('@/assets/exam/theme1/3.png'),
          '--dialog-bg-img': 'url(' + require('@/assets/exam/theme1/dialog_bg.png') + ')'
        },
        {
          '--progress-tip-bg': require('@/assets/exam/theme0/3.png'),
          '--dialog-bg-img': 'url(' + require('@/assets/exam/theme0/dialog_bg.png') + ')'
        },
      ]
    };
  },
  props: ['dataSource', 'type', 'surveyNoPrefix'],
  methods: {
    changeTheme(theme) {
      for (const key in theme) {
        if (Object.hasOwnProperty.call(theme, key)) {
          const element = theme[key]
          document.documentElement.style.setProperty(key, element)
        }
      }
    },
    async submitInfo(sonData, currentQSmall) {
      // 若明确设置了 surveyNoPrefix，则生成一个 surveyNo 给 saveSurveyResult
      const surveyNo = this.$props.surveyNoPrefix
        ? this.$props.surveyNoPrefix + currentQSmall
        : ''
      saveSurveyResult(this.$refs.answer, surveyNo)

      const isEndDataSource = this.current + 1 === this.dataSource.length // 最后一道题
      const isEndExam = JSON.parse(sessionStorage.currentExamGroup).exam.length - 1 == sessionStorage.currentExamIndex // 最后一套试卷
      const data = Object.assign({
        exam_id: 1,
        exam_num: this.subSource.length > 0 ? currentQSmall + '_' + this.subSource[this.current].value.length : currentQSmall + '_' + this.dataSource[this.current].length,
        subject_id: 12 + this.type,
        subject_name: this.type === 1 ? '学生问卷' : this.type === 2 ? '教师问卷' : this.type === 3 ? '批判调查问卷' : '创新调查问卷',
        pic_info: '答案',
        status: (isEndDataSource && isEndExam) ? 1 : 2
      }, sonData)
      const res = await answerUpload(data)
      this.loading = false
      if (!res || res.code != '200') {
        this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
        return
      }
      if (isEndDataSource) {
        if (isEndExam) {
          this.$message.info('测评结束')
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        } else {
          sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
          this.$router.push({
            name: JSON.parse(sessionStorage.currentExamGroup).exam[sessionStorage.currentExamIndex]
          })
        }
      } else {
        this.current = this.current + 1;
        this.list = this.dataSource[this.current];
        if (this.current + 1 === this.dataSource.length) {
          this.text = '谢谢你的作答！提交问卷。'
        }
        this.returnTop()
        this.dataTracking()
      }
    },
    next() {
      this.hasNoWord()
      if (this.currentNoWord) {
        this.show = true
      } else {
        if (sessionStorage.userInfo) {
          this.loading = true
          const userInfo = JSON.parse(sessionStorage.userInfo)
          document.getElementsByClassName('right')[0].scrollTop = 0
          setTimeout(() => {
            htmlToFile(this.$refs.answer, (file) => {
              sessionStorage.removeItem('selectedQidSmall')
              this.submitInfo({
                stu_num: userInfo.stu_num,
                exam_file: file
              }, this.current + 1)
            })
          }, 1000);

          // 单独添加数据埋点
          const value = ''
          const elData = typeof value === 'string' ? parseStatsData(value) : value
          delete elData.event2
          delete elData.note2
          const data = {
            topic: '',
            statsVar: this.dataStatsVar,
            ...elData,
            event: 'questionnaire_submit'
          }
          postProcessStats(data, 'click')
        } else {
          this.$message({
            message: '请登录后再答题！',
            type: 'error'
          })
        }
      }
    },
    hasNoWord() {
      const arr = []
      for (let index = 0; index < this.dataSource[this.current].length; index++) {
        const item = this.dataSource[this.current][index];
        if (item.type === 2) {
          if (!item.answer) arr.push(item)
        } else if (item.type === 4) {
          item.value.forEach(it => {
            if (!it.answer) arr.push(it)
          })
        } else if (item.type === 6 || item.type === 8) {
          if (item.answerList.length === 0) arr.push(item)
        }
      }
      this.currentNoWord = arr.length > 0 ? arr[0] : null
      console.log('this.currentNoWord ----->', arr, this.currentNoWord)
    },
    continueWord() {
      this.handleScroll('id' + this.currentNoWord.headline)
      this.show = false
    },
    handleScroll(id) {
      var element = document.getElementById(id);
      element && element.scrollIntoView(); // 参数 false 代表 Bottom
    },
    returnTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    initTime() {
      const timer = setInterval(() => {
        if (sessionStorage.examTime) {
          const cha = (new Date().getTime() - sessionStorage.examTime) / 1000
          const repair1 = Math.floor(cha / 60) <= 9 ? '0' : ''
          const repair2 = cha % 60 <= 9 ? '0' : ''
          this.time = repair1 + Math.floor(cha / 60) + ':' + repair2 + Math.floor(cha % 60);
          this.percentage = this.type === 2 ? Math.min(cha / 60 / 60 * 100, 100) : Math.min(cha / 60 / 30 * 100, 100);
          this.left = this.percentage + '%'
          if (this.percentage === 100) {
            clearInterval(timer)
          }
          this.minute = this.type === 2 ? Math.min(60, Math.floor(cha / 60)) : Math.min(30, Math.floor(cha / 60))
          // console.log(cha)
        } else {
          sessionStorage.examTime = new Date().getTime()
          this.time = '00:00';
          this.percentage = 0;
        }
      }, 1000);
    },
    dataTracking() {
      let topic
      if (this.type !== 3) {
        topic = (this.type === 1 ? '学生问卷' : this.type === 2 ? '教师问卷' : this.type === 3 ? '批判调查问卷' : '创新调查问卷') + (this.type === 1 || this.type === 2 ? ('-第' + this.subSource[this.current].title + '大题(1-' + this.subSource[this.current].value.length + ')') : '')
        sessionStorage.setItem('statsCurrentTopic', topic)
      } else {
        // const key = 'Survey-'
        // const statsCurrentTopic = sessionStorage.getItem('statsCurrentTopic')
        // if (statsCurrentTopic.includes(key) === false) {
        //   topic = key + statsCurrentTopic
        // } else {
        //   topic = statsCurrentTopic
        // }
        // sessionStorage.setItem('statsCurrentTopic', topic)
      }
      postProcessStats({ category: '', event: 'enter_page' })
    },
    /**
     * type 值: 学生问卷 1  教师问卷 2 批判调查问卷 3  创新调查问卷  4
     * category 值：创新任务  1  批判任务 2  创新学生问卷 3 创新老师问卷 4
     */
    initCategory() {
      switch (this.type) {
        case 1:
          sessionStorage.setItem('examCategory', 3)
          break;
        case 2:
          sessionStorage.setItem('examCategory', 4)
          break;
        case 3:
          sessionStorage.setItem('examCategory', 2)
          break;
        case 4:
          sessionStorage.setItem('examCategory', 1)
          break;
        default:
          break;
      }
    },
  },
  created() {
    const selectedQidSmall = sessionStorage.getItem('selectedQidSmall')

    if (selectedQidSmall) {
      this.current = Number(selectedQidSmall)
    }
    this.list = this.dataSource[this.current];
    this.initTime()
    if (this.current + 1 === this.dataSource.length) {
      this.text = '谢谢你的作答！提交问卷。'
    }
    if (this.type === 1) {
      this.changeTheme(this.themeList[0])
    } else if (this.type === 2) {
      this.changeTheme(this.themeList[1])
    } else if (this.type === 3) {
      this.changeTheme(this.themeList[2])
    } else {
      this.changeTheme(this.themeList[3])
    }
    // if (this.type === 3) return
    console.log('this.dataSource ----->', this.dataSource)
    this.dataSource.find((item, index) => {
      const obj = {
        title: ['一', '二', '三', '四', '五'][index],
        value: []
      }
      item.forEach(it => {
        if (it.type === 2 || it.type === 4 || it.type === 6) {
          obj.value.push(it)
        }
      });
      this.subSource.push(obj)
    })
    this.initCategory()
    this.dataTracking()
  },
};
</script>
<style lang="less" scoped>
.main {
  font-size: 20px;
  height: auto;
  // padding: 20px 70px 80px 70px;
  padding: 0 30px 40px 140px;
  background-color: #e8f8ff;
  font-family: Kaiti SC, Kaiti SC-Bold, '楷体';
  font-weight: 700;
  .headerTop {
    height: 66px;
    line-height: 66px;
    text-align: center;
    img {
      width: 206px;
      margin-top: 20px;
    }
  }
  .content{
    background-color: #fff;
    border-radius: 12px;
    border: 2px solid #0a7297;
    padding-bottom: 20px;
  }
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: 110px;
    height: 100vh;
    background: #587462;
    > img{
      width: 66px;
      height: 66px;
      margin: 0 auto;
      margin-top: 14px;
      margin-bottom: 26px;
      display: block;
    }
    > div{
      background: #fff;
      border-radius: 0 6px 6px 0;
      padding: 2px 2px 2px 0;
      width: 92px;
      .list{
        width: 100%;
        min-height: 80px;
        font-family: '楷体';
        background-image: linear-gradient(#badee8, #9acadd);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 36px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        margin-bottom: 1px;
        position: relative;
        span:last-child{
          font-size: 20px;
        }
      }
      .select{
        background-image: linear-gradient(#c5E599, #91bb57);
      }
    }
  }
}
.elapsedTime {
  display: flex;
  margin: 23px;
  justify-content: flex-end;
  span{
    font-size: 18px;
  }
  .progress {
    width: 270px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    position: relative;
    > div:nth-child(1){
      width: 100%;
    }
    .pastTime{
      position: absolute;
      margin-left: -25px;
      top: 21px;
      background-size: 100% 100%;
      width: 52px;
      height: 21px;
      text-align: center;
      span{
        font-size: 24px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 26px;
        transform: scale(0.5);
        display: block;
        position: relative;
        width: 200%;
        margin-left: -25px;
      }
    }
  }
  .time {
    color: #696969;
    padding-left: 12px;
    font-size: 18px;
  }
}
.front {
  // border-bottom: 1px solid #e9e9e9;
  // padding-bottom: 20px;
  font-weight: 600;
  font-family: '楷体';
  .header {
    padding: 30px 0px;
    width: 100%;
    font-size: 30px;
    text-align: center;
    color: #007a93;
  }
  .list {
    padding: 10px 32px;
    font-size: 20px;
    text-indent: 2em;
    line-height: 1.5;
    color: #242424;
  }
  .listFirst {
    text-indent: 0em;
    padding: 0 32px;
    padding-top: 28px;
  }
}
.title {
  margin-top: 40px;
  font-size: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: left;
  color: #000000;
  padding: 0 37px;
  font-family: '楷体';
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  > div{
    width: 40px;
    height: 40px;
    // border-radius: 50%;
    // background-image: linear-gradient(#c5E599, #91bb57);
    // margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #000;
    font-family: "楷体";
    font-weight: bold;
  }
  > span{
    flex: 1;
    font-size: 20px;
    font-weight: 700;
  }
}
.titleSmall {
  margin-left: 59px;
  margin-right: 59px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .titleSmall_title{
    display: flex;
    align-items: center;
    font-size: 18px;
    min-height: 48px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 23px;
    border-bottom: 2px solid #fff;
  }
  .list {
    // display: flex;
    .headline {
      font-size: 18px;
      align-items: center;
      margin-right: 59px;
      // width: 100%;
      min-height: 48px;
      background: #f8f8f8;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: 0 23px;
    }
    .select {
      min-height: 53px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 40px;
      .selectRadio {
        display: flex;
        align-items: center;
        line-height: 33px;
        /deep/.el-radio__inner {
          border-color: #3c3c3c;
        }
        /deep/.el-radio__input.is-checked .el-radio__inner{
          border-color: #587462;
          background: #587462;
        }
        /deep/.el-radio__input.is-checked+.el-radio__label{
          color: #587462;
        }
        /deep/ .el-radio__label {
          // padding-top: 4px;
          font-size: 16px;
        }
        span {
          font-size: 16px;
        }
        /deep/.el-input,
        /deep/.el-input__inner {
          min-width: 300px;
          background: transparent;
          border: 0;
          border-bottom: 1px solid;
          padding: 0;
          height: 25px;
          line-height: 25px;
        }
        .selected_radio {
          /deep/.el-input__inner {
            color: #409eff !important;
          }
        }
      }
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          display: flex;
          align-items: center;
          /deep/.el-checkbox__label {
            padding-top: 4px;
            font-size: 16px;
            line-height: 2;
          }
          /deep/.el-checkbox__inner {
            border-color: #3c3c3c;
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
            border-color: #587462;
            background: #587462;
          }
          /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
            color: #587462;
          }
        }
      }
    }
  }
}
.pascal {
  // margin-top: 20px;
  // margin: 20px 0px;
  .list {
    // display: flex;
    .headline {
      font-size: 18px;
      align-items: center;
      margin-left: 59px;
      margin-right: 59px;
      // width: 100%;
      min-height: 48px;
      background: #f8f8f8;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: 0 23px;
    }
    .select {
      min-height: 53px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 90px;
      .selectRadio {
        display: flex;
        align-items: center;
        line-height: 33px;
        /deep/.el-radio__inner {
          border-color: #3c3c3c;
        }
        /deep/.el-radio__input.is-checked .el-radio__inner{
          border-color: #587462;
          background: #587462;
        }
        /deep/.el-radio__input.is-checked+.el-radio__label{
          color: #587462;
        }
        /deep/ .el-radio__label {
          // padding-top: 4px;
          font-size: 16px;
        }
        span {
          font-size: 16px;
        }
        /deep/.el-input,
        /deep/.el-input__inner {
          min-width: 300px;
          background: transparent;
          border: 0;
          border-bottom: 1px solid;
          padding: 0;
          height: 25px;
          line-height: 25px;
        }
        .selected_radio {
          /deep/.el-input__inner {
            color: #409eff !important;
          }
        }
      }
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          display: flex;
          align-items: center;
          /deep/.el-checkbox__label {
            padding-top: 4px;
            font-size: 16px;
            line-height: 2;
          }
          /deep/.el-checkbox__inner {
            border-color: #3c3c3c;
          }
          /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
            border-color: #587462;
            background: #587462;
          }
          /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
            color: #587462;
          }
        }
      }
    }
  }
}
.next {
  width: 269px;
  height: 44px;
  background: #f8f9ff;
  border-radius: 22px;
  display: flex;
  background: #587462;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 550;
  color: #fff;
  line-height: 20px;
  margin: 0 auto;
  margin-top: 37px;
  cursor: pointer;
}
/deep/.el-dialog--center{
  background-image: var(--dialog-bg-img);
  background-size: 100% 100%;
  box-shadow: none;
  background-color: transparent;
  .el-dialog__body{
    .text{
      width: 60%;
      margin: 20px auto 0 auto;
      font-size: 18px;
      color: #000;
      font-family: '楷体';
      text-align: center;
    }
  }
  .el-dialog__footer{
    .dialog-footer{
      margin-bottom: 30px;
      .el-button{
        font-size: 16px;
        width: 75px;
        height: 35px;
        padding: 5px;
        color: var(--button-bg-color);
        border-color: #ccc;
        >span{
          font-size: 16px;
          font-family: '楷体';
        }
      }
      .el-button:focus, .el-button:hover{
        background-color: #FFF;
      }
      .el-button.el-button--primary,.el-button--primary:focus, .el-button--primary:hover{
        color: #fff;
        background-color: var(--button-bg-color);
        border-color: var(--button-bg-color);
        margin-right: 10px;
      }
    }
  }
}
.teacher, .student {
  background: #fff;
  background-image: url("~@/assets/exam/theme0/bj_d_top@2x.png"), url("~@/assets/exam/theme0/bj_d_bottom@2x.png");
  background-repeat: no-repeat, no-repeat;
  background-position: left top, left bottom;
  background-size: 100% auto, 100% auto;
  .content{
    border-color: #B2B58A;
    background-image: url('~@/assets/exam/theme0/bj_nr@2x.png');
    background-size: 100% auto;
    .title > div{
      // background-image: linear-gradient(#badee8, #9acadd);
    }
  }
  .sidebar{
    background: #587462;
    > div{
      .list{
        color: #6F8476;
        background-image: linear-gradient(#D1EBD1, #D1EBD1);
      }
      .select{
        color: #fff;
        background-image: linear-gradient(#488360, #488360);
      }
    }
  }
  .next{
    background-color: #587462;
  }
  /deep/ .el-progress-bar__outer {
    background-color: #D2E5D4;
  }
}
.criticism{
  background: #fff;
  height: 100%;
  background-image: url('~@/assets/exam/theme1/bj_d@2x.png');
  background-size: 100% 100%;
  padding-left: 30px;
  padding-top: 30px;
  .content{
    border-color: #fff;
    .title{
      padding: 0 70px;
    }
    .pascal {
      .list {
        .select {
          .selectRadio {
            /deep/.el-radio__input.is-checked .el-radio__inner{
              border-color: #5B4068;
              background: linear-gradient(180deg, #5B4068 0%, #5B4068 100%);
            }
            /deep/.el-radio__input.is-checked+.el-radio__label{
              color: #5B4068;
            }
            .selected_radio {
              /deep/.el-input__inner {
                color: #5B4068;
              }
            }
          }
          .el-checkbox-group {
            .el-checkbox {
              /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
                border-color: #5B4068;
                background: linear-gradient(180deg, #5B4068 0%, #5B4068 100%);
              }
              /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
                color: #5B4068;
              }
            }
          }
        }
        .record{
          width: calc(100% - 164px);
          margin-left: 82px;
        }
      }
    }
  }
  .next{
    background: linear-gradient(180deg, #5B4068 0%, #5B4068 100%);
    box-shadow: 0px 5px 6px -4px rgba(74,0,147,0.46), inset 0px 3px 8px 0px rgba(255,255,255,0.3);
  }
  /deep/.el-input__inner{
    width: auto;
    color: #5B4068 !important;
    border: 0;
    border-bottom: 1px solid ;
    border-radius: 0;
    padding: 0;
    height: auto;
    line-height: normal;
  }
}
.innovation{
  background: #fff;
  height: 100%;
  background-image: url('~@/assets/exam/theme0/bj_d_top@2x.png');
  background-size: 100% 100%;
  padding-left: 30px;
  padding-top: 30px;
  .content{
    border-color: #B2B58A;
    background-image: url('~@/assets/exam/theme0/bj_nr@2x.png');
    background-size: 100% auto;
    .title{
      padding: 0 70px;
    }
    .pascal {
      .list {
        .select {
          .selectRadio {
            /deep/.el-radio__input.is-checked .el-radio__inner{
              border-color: #587462;
              background: linear-gradient(180deg, #587462 0%, #587462 100%);
            }
            /deep/.el-radio__input.is-checked+.el-radio__label{
              color: #587462;
            }
            .selected_radio {
              /deep/.el-input__inner {
                color: #587462;
              }
            }
          }
          .el-checkbox-group {
            .el-checkbox {
              /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
                border-color: #587462;
                background: linear-gradient(180deg, #587462 0%, #587462 100%);
              }
              /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
                color: #587462;
              }
            }
          }
        }
        .record{
          width: calc(100% - 164px);
          margin-left: 82px;
        }
      }
    }
  }
  .next{
    background: linear-gradient(180deg, #587462 0%, #587462 100%);
    box-shadow: 0px 5px 6px -4px rgba(0,122,147,0.46), inset 0px 3px 8px 0px rgba(255,255,255,0.3);
  }
}

// .student {
//   background: #f8fce4;
//   background-image: url('~@/assets/exam/theme1/bj_d@2x.png');
//   background-size: 100% 100%;
//   .content{
//     border-color: #BCA7C9;
//     background-image: url('~@/assets/exam/theme1/bj_nr@2x.png');
//     background-size: 100% auto;
//     .title > div{
//       background-image: linear-gradient(#badee8, #9acadd);
//     }
//   }
//   .sidebar{
//     background: #5E2E56;
//     > div{
//       .list{
//         color: #5E2E56;
//         background-image: linear-gradient(#CDC0E3, #CDC0E3);
//       }
//       .select{
//         color: #fff;
//         background-image: linear-gradient(#8A457F, #8A457F);
//       }
//     }
//   }
//   .next{
//     background-color: #5E2E56;
//   }
//   /deep/ .el-progress-bar__outer {
//     background-color: #CDBAD6;
//   }
//   .pascal {
//     .list {
//       .select {
//         .selectRadio {
//           /deep/.el-radio__input.is-checked .el-radio__inner{
//             border-color: #5E2E56;
//             background: linear-gradient(180deg, #5E2E56 0%, #5E2E56 100%);
//           }
//           /deep/.el-radio__input.is-checked+.el-radio__label{
//             color: #5E2E56;
//           }
//           .selected_radio {
//             /deep/.el-input__inner {
//               color: #5E2E56;
//             }
//           }
//         }
//         .el-checkbox-group {
//           .el-checkbox {
//             /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
//               border-color: #5E2E56;
//               background: linear-gradient(180deg, #5E2E56 0%, #5E2E56 100%);
//             }
//             /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
//               color: #5E2E56;
//             }
//           }
//         }
//       }
//     }
//   }
// }
</style>
